import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecentlySelectedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RecentlySelected",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.97 15.1c0-.3-.06-.6-.1-.89A12.86 12.86 0 0 0 17.73 3.13h-.63c-5.22 0-9.91 3.15-11.88 7.98H2.47c-.19 0-.35.11-.43.28s-.05.37.08.51l4.1 4.38c.08.09.2.15.33.15s.26-.05.35-.15L11 11.9a.46.46 0 0 0 .09-.5.47.47 0 0 0-.43-.29h-2.8l.3-.51c1.87-3.16 5.27-5.09 8.94-5.08h.2c4.94.12 9.14 3.66 10.07 8.51.08.41.13.83.15 1.25.2 2.89-.82 5.73-2.82 7.83-3.93 4.21-10.53 4.44-14.74.51-.7-.66-1.31-1.41-1.81-2.23a1.2 1.2 0 0 0-2.1 0c-.22.39-.22.86 0 1.25 3.67 6.09 11.57 8.06 17.67 4.39a13 13 0 0 0 2.77-2.24c2.47-2.59 3.74-6.11 3.48-9.69M16.58 8.69a.97.97 0 0 0-.97.97v7.42c0 .26.09.52.28.71.16.12.34.22.53.29l6.2 2.11a.97.97 0 0 0 1.19-.59c.16-.54-.11-1.11-.63-1.33l-5.6-1.87V9.7a.97.97 0 0 0-.93-1.01h-.08Z"
    })
  }));
};